import { UserClassification } from '@Models/types';
import TabPanel from './TabPanel';
import NewUserSettings from '@New/NewUserSettings';

interface WrapperTabPanelProps {
  index: number;
  requiredKeys: Array<'aha' | 'testrail'>;
  children: React.ReactNode;
  userType: UserClassification;
  ahaOnly?: boolean;
}

const WrapperTabPanel = ({
  index,
  requiredKeys,
  children,
  userType,
  ahaOnly,
}: WrapperTabPanelProps) => {
  const missingKeys: Array<
    'aha_api_key' | 'testrail_username' | 'testrail_api_key'
  > = [];

  if (
    requiredKeys.includes('aha') &&
    (userType === 'no-api' || userType === 'only-testrail')
  ) {
    missingKeys.push('aha_api_key');
  }

  if (
    requiredKeys.includes('testrail') &&
    (userType === 'no-api' || userType === 'only-aha')
  ) {
    missingKeys.push('testrail_username', 'testrail_api_key');
  }

  const showSettings = missingKeys.length > 0;

  return (
    <TabPanel index={index}>
      {showSettings ? (
        <NewUserSettings missing={missingKeys} ahaOnly={ahaOnly} />
      ) : (
        children
      )}
    </TabPanel>
  );
};

export default WrapperTabPanel;
